import axios from "axios";
import { encodeUrlFromRouter, encodeUrlToRouter } from "@/routerUrlEncoding";

export default {
  name: "DmSelectBatch",
  components: {
    CircleLoadingIndicator:
      require("@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue")
        .default,
    DmBatchesList: require("./dmSelectBatchList.vue").default,
    BackButton: require("@/components/backButton/backButton.vue").default,
  },
  data: function () {
    return {
      billGroupKey: null,
      billGroups: [],
      disconnections: [],
      reconnections: [],
      allBatches: [],
      isLoading: false,
      activeTab: "billingGroups",
      selectedItemId: -1,
    };
  },
  computed: {
    batchesPresent: function () {
      return (
        (this.disconnections && this.disconnections.length > 0) ||
        (this.reconnections && this.reconnections.length > 0)
      );
    },
  },
  watch: {
    billGroupKey: function (val) {
      if (!val) return;

      this.getBatches();
    },
  },
  created() {
    this.$store.dispatch("resetDebtManagementLocalDB");
    this.$store.dispatch("setDmSelectionSettings", { reset: true });

    this.getBillGroups();
  },
  mounted() {
    this.getSelectedItem();
  },
  methods: {
    tabChanged(tab) {
      this.activeTab = tab;
      this.$store.dispatch("setDmSelectionSettings", { tab: this.activeTab });
    },
    getSelectedItem() {
      let selection = this.$store.getters.getDmSelectionSettings;
      if (selection) {
        if (selection.tab) this.activeTab = selection.tab;

        if (selection.batchIdSelected)
          this.selectedItemId = selection.batchIdSelected;
      }
    },
    getBillGroups() {
      this.isLoading = true;
      this.$forceUpdate();
      axios
        .get("/DmConnection/GetBillGroupsBatches")
        .then((response) => {
          if (response.status == 200) {
            this.billGroups = response.data ?? [];
          } else this.$oldAlertMsg(this.$t("disconnections.BatchesError"));
        })
        .catch((e) => {
          this.$oldAlertMsg(this.$t("disconnections.BatchesError"));
        })
        .finally(() => {
          this.isLoading = false;

          if (this.selectedItemId > 0)
            setTimeout(() => {
              this.$scrollToElement(this.selectedItemId);
            }, 1000);
        });
    },
    getBatches() {
      this.isLoading = true;

      this.disconnections.length = 0;
      this.reconnections.length = 0;
      this.allBatches.length = 0;
      //tbi billing group
      axios
        .get(
          "/DmConnection/GetEmployeeBatchesPerBillGroup?billGroup=" +
            this.billGroupKey
        )
        .then((response) => {
          if (response.status == 200) {
            this.allBatches = response.data ?? [];
            this.prepareItemsLists();
            if (this.disconnections.length > 0)
              this.activeTab = "disconnections";
            else this.activeTab = "reconnections";
          } else this.$oldAlertMsg(this.$t("disconnections.BatchesError"));
        })
        .catch((e) => {
          this.$oldAlertMsg(this.$t("disconnections.BatchesError"));
        })
        .finally(() => {
          this.isLoading = false;

          if (this.selectedItemId > 0)
            setTimeout(() => {
              this.$scrollToElement(this.selectedItemId);
            }, 1000);
        });
    },
    prepareItemsLists() {
      if (this.allBatches.length == 0) return;

      this.reconnections = this.allBatches.filter(
        (a) => a.activity == "Reconnections"
      );
      this.disconnections = this.allBatches.filter(
        (a) => a.activity == "Disconnections"
      );

      if (this.reconnections.length > 0)
        this.reconnections.sort((a, b) => (a.batchNo > b.batchNo ? 1 : -1));

      if (this.disconnections.length > 0)
        this.disconnections.sort((a, b) => (a.batchNo > b.batchNo ? 1 : -1));
    },
    selectedBillGroup(item) {
      if (!item.key) return;
      this.billGroupKey = item.key;
    },
    selectItem(item) {
      if (!item) return;

      this.isLoading = true;
      this.$store.dispatch("setDmSelectionSettings", {
        batchIdSelected: item.batchNo,
      });
      let route = `/debtManagementSelectWalk/${encodeUrlToRouter(
        this.billGroupKey
      )}/${encodeUrlToRouter(item.activityStage)}/${encodeUrlToRouter(
        item.batchNo
      )}`;
      this.$router.push(route);
    },

    getLabels(type) {
      let texts = [
        type == "disc"
          ? this.$t("disconnections.Disconnections")
          : this.$t("disconnections.Reconnections"),
        `${this.$t("enquiriesReadingsDetails.for")} ${this.billGroupKey}`,
      ];

      let color = type == "disc" ? "color-red-text" : "color-blue-text";

      return { color, texts };
    },
  },
};
